import React, { Component } from 'react'
import axios from 'axios';
import FormCuestions from './QuestionsContainer.js';
import FormUser from './FormUser.js';
import logo_ios from '../../images/Logo_IOS_2022.png';
import image from '../../images/mejora_continua.png';
import '../../CSS/feedback.css';
import { translate } from 'react-i18next';

let cancelToken;
class FeedBackContainer extends Component{
    constructor(props) {
        super(props);
        this.state ={
            objCenters: {},
            objUser: {},
            open: false,
            close: false,
            form_user: false,
            form_cuestion: false,
            shearingEmail: true,
            error: '',
            pollId: 0,
            errorPoll: '',
            // Info socio
            socio: '',
            socio_id: 0,
            empresa: '',
            email: '',
            suite: '',
            centro: '',
            centro_id: '',
            ciudad: '',
            ciudad_id: '',
            telefono: ''
        }
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    handleInputChangeEmail = (e) => { this.setState({email: e.target.value, shearingEmail: false}) }

    handleClickEmail = () => {//clic validate mail
        if(this.emailValidation()){// Succes mail
            this.getUserEmail()
        }  
    }

    
    // Validar correo
    emailValidation(){
        const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if(!this.state.email || regex.test(this.state.email) === false){
            this.setState({error: 'Correo invalidó, inténtelo de nuevo', shearingEmail:true});
            return false;
        }
        return true;
    }
    // Llamar web service para aurenticar correo
    getUserEmail = () => {
        this.setState({shearingEmail: true, sendPost: true})
        let params = {email: this.state.email};
        params.token_id = this.props.getTokenId();
        this.props.post("/improvement/searchEmail", params, (response) => this.handleSuccesUser(response), (error) => this.handleErrorUser(error), cancelToken);
    }

    // Response web service searchEmail
    handleSuccesUser = (response) => {
        // VAlidacion par identificar si el correo existe o no dentro de la base de datos IOS
        if (response.length > 0) {
            this.setState({objUser: response[0], socio: response[0].socio, socio_id: response[0].socio_id, empresa: response[0].empresa, suite: response[0].oficina, centro: response[0].centro, centro_id: response[0].centro_id, ciudad: response[0].ciudad, ciudad_id: response[0].ciudad_id, telefono: response[0].telefono})
        } else {
            this.setState({objUser: {},socio: '', socio_id: 0, empresa: '', suite: '', centro: '', centro_id: '', ciudad: '', ciudad_id: '', telefono: ''})
        }
        this.setState({ open: true, close: true, form_user: true, sendPost: false })
    }

    // Web service error
    handleErrorUser = (codeError, param_uno, param_dos, msgError) => { this.setState({shearingEmail: false, sendPost:false, socio: '', socio_id: 0, empresa: '', suite: '', centro: '', centro_id: '', ciudad: '', ciudad_id: '', telefono: ''});}

    handleInputChange = (event) => {
        let input = event.target.name;
        this.setState({[input]: event.target.value})
    }

    // Clic ciudad (Peticion ws centros)
    handleInputChangeCity = (event) => {
        this.setState({ciudad_id: event.target.value, centro_id: ''})
        let params = {token_id: this.props.getTokenId(), ciudad_id: event.target.value}
        this.props.post("/improvement/getCenters", params, (response) => this.handleSuccesCenter(response), (error) => this.handleErrorCenter(error), cancelToken);
    }

    handleSuccesCenter = (response) => { this.setState({objCenters: response}) }
    // Web service centers error
    handleErrorCenter = (codeError, param_uno, param_dos, msgError) => { this.setState({objCenters: {}});}

    // Clic centro
    handleInputChangeCenter = (e) => {
        this.setState({centro_id: e.target.value})
    }

    // Post form (crear encuesta)
    handleSubmitUser = (event) => {
        event.preventDefault();
        let params = this.state;
        params.token_id = this.props.getTokenId();
        if (params.centro_id > 0) {
            this.props.post('/improvement/cretePoll', params, (response) => this.handleSuccesPoll(response), (error) => this.handleErrorPoll(error), cancelToken )
        }
    }

    handleSuccesPoll = (response) => { this.setState({pollId: response, form_cuestion: true, errorPoll: ''}) }

    handleErrorPoll = (codeError, param_uno, param_dos, msgError) => { this.setState({response: 0, errorPoll: 'Error al autenticar datos.'}) }

    // Contenedor para dibujar preguntas de encuesta
    renderQuestion = () => {
        return(
            <FormCuestions 
                getTokenId = {this.props.getTokenId()}
                post = {this.props.post}
                info = {this.state}
            />
        )
    }

    // Contenedor para dibujar formulario de usuario
    renderForm = () => {
        return (
            <FormUser
                getTokenId = {this.props.getTokenId()}
                post = {this.props.post}
                info = {this.state}
                handleInputChange = {this.handleInputChange}
                handleInputChangeCity = {this.handleInputChangeCity}
                handleInputChangeCenter  = {this.handleInputChangeCenter}
                handleSubmitUser = {this.handleSubmitUser}
            />
        )
    }

    render() {
        const { t } = this.props;
        return (
            <div id="encuesta">                
                <div className="panel panel-default">
                    <div className="page-heading container-fluid">
                        <nav className="navbar navbar-default" style={{background: '#fff'}}>
                            <div className="navbar-header">
                                <div className="navbar-brand" >
                                    <img alt="IOS OFFICES" className="brand-logo" src={logo_ios}  />
                                </div>
                            </div>
                            <div className="nav text-center title-section">
                                <h1 style={{marginTop: '30px'}}>{t('dashboard.question.title')}</h1>
                            </div>
                        </nav>
                    </div>    
                    {this.state.form_cuestion ? this.renderQuestion()  : this.infoUser()}
                </div>
            </div>
        )
    }

    // Cotenedor para inciar encuesta
    infoUser = () => {
        const { t } = this.props;
        return (
            <div className="panel-body jumbotron container-fluid form_user" style={{paddingTop: '3%'}}>
                <div className="row">
                    <div className="col-md-6 col-sm-12">
                        <div className="page-header panel-title text-left section_text" >
                            <h2 id="subtitle-section">{t('dashboard.question.slogan')}</h2>
                        </div>
                        {this.state.form_user ? this.formUser() : this.sectionMail()}
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <img className="image-form" alt="IOS OFFICES" src={image} />
                    </div>
                </div>
            </div>
        )
    }

    // Contenedor par dibujar paso 1 Input correo y boton para validar
    sectionMail = () => {
        const { t } = this.props;
        const hide = this.state.close ? 'form-mail div_out' : 'form-mail'
        return (
            <div className={hide} >
                <div className="form-group">
                    <h4>{t('dashboard.question.who')}</h4>
                </div>
                <div className="form-group col-md-12" style={{paddingLeft: '0px'}}>
                    <input type="email" className="form-control mail_user" placeholder="example@iosoffices.com" onChange={this.handleInputChangeEmail} ></input>
                    {/* value="kevin.velazquez@iosoffices.com" */}
                    <button type="button" className="btn-start" onClick={()=>this.handleClickEmail()} disabled={this.state.shearingEmail}>{t('dashboard.question.botooms.validation')}</button>
                </div>
                <div className="form-group col-md-12">
                    <p className="message-warning">{this.state.error}</p>
                </div>
            </div>
        )
    }

    formUser = () => {
        const show = this.state.open ? 'form-socio div_show' : ''
        return (
            <div className={show}>
                {this.renderForm()}
            </div>
        )
    }

}


export default translate('common')(FeedBackContainer);




// WEBPACK FOOTER //
// ./src/guest/improvement/FeedBack.js